@if ((totalElements || 0) > elementsPerPage) {
  <div class="btn-group pb-1">
    <button type="button" class="btn btn-secondary" [disabled]="isFirstPage" (click)="goToFirstPage()">First</button>
    @for (betweenPageNumber of inBetweenPages; track betweenPageNumber) {
      <button type="button" class="btn" [ngClass]="betweenPageNumber === pageNumber ? 'btn-outline-secondary' : 'btn-secondary'" [disabled]="betweenPageNumber === pageNumber" (click)="goToPage(betweenPageNumber)">{{betweenPageNumber}}</button>
    }
    <button type="button" class="btn btn-secondary" [disabled]="isLastPage" (click)="goToLastPage()">Last</button>
  </div>
}